import {NavLink, useNavigate} from "react-router-dom";
import classNames from "classnames";
import Button from "../Button/Button";
import Icon, {separatorIcon} from "../Icon/Icon";
import "./PageLayout.scss";

const PageLayout = ({
                        titlePage,
                        titlePageContent,
                        icon,
                        actions,
                        headerTabs = [],
                        currentTab,
                        onTabChange,
                        handleUnsavedChanges,
                        className,
                        children
                    }) => {
    const navigate = useNavigate();

    const handleNavigate = (path) => {
        if (handleUnsavedChanges) {
            handleUnsavedChanges(path);
        } else {
            navigate(path);
        }
    };

    return (
        <div className='page-layout'>
            <header className="header">
                {icon && (
                    <Icon svg={icon} className="page-icon" />
                )}

                <Button
                    className="topbar"
                    onClick={() => handleNavigate(`/${window.location.pathname.split("/")[1]}`)}
                >
                    {titlePage}
                </Button>

                {titlePageContent && (
                    <>
                        <Icon svg={separatorIcon} className="separator" />
                        <p>{titlePageContent}</p>
                    </>
                )}

                {headerTabs.length > 0 && (
                    <div className="tabs">
                        {headerTabs.map(tab => (
                            tab.path ? (
                                <NavLink
                                    key={tab.tabId}
                                    to={tab.path}
                                    end
                                    onClick={e => {
                                        if (tab.disabled) {
                                            e.preventDefault();
                                            return;
                                        }

                                        if (handleUnsavedChanges) {
                                            e.preventDefault();
                                            handleUnsavedChanges(tab.path);
                                            return;
                                        }

                                        onTabChange?.(tab.tabId);
                                    }}
                                    className={classNames("tab", {
                                        "active-tab": currentTab === tab.tabId,
                                        "disabled": tab.disabled
                                    })}
                                >
                                    {tab.label}
                                </NavLink>
                            ) : (
                                <button
                                    key={tab.tabId}
                                    type="button"
                                    disabled={tab.disabled}
                                    onClick={() => onTabChange?.(tab.tabId)}
                                    className={classNames("tab", {
                                        "active-tab": currentTab === tab.tabId
                                    })}
                                >
                                    {tab.label}
                                </button>
                            )
                        ))}
                    </div>
                )}

                <div className='actions'>
                    {actions}
                </div>
            </header>

            <section className={classNames("content", className)}>
                {children}
            </section>
        </div>
    );
};

export default PageLayout;